import { useState } from "react";
// redux
import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
// models
import { PostulacionModel, initialValuesPostulacionModel } from "../models/PostulacionesModel/postulacion.model";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { useEncrypt } from "./useEncrypt";

export const usePostulacion = () => {
  const { decrypt } = useEncrypt();
  // state
  const [postulacion, setPostulacion] = useState<PostulacionModel>(initialValuesPostulacionModel);
  // function
  const cargarPostulacion = async () => {
    let { data } = await apiConvocatorias.getConvocatoriaById(decrypt(localStorage.getItem("idConvocatoriaPostulacion")))
    //console.log(data, 'áquii')
    if (data.documentos_administrativos === null) data.documentos_administrativos = [];
    if (data.documentos_generales === null) data.documentos_generales = [];
    if (data.documentos_tecnicos === null) data.documentos_tecnicos = [];
    return setPostulacion(data);
  };

  const cargarPostulacionTipoParticipante = async () => {
    // let { data } = await apiParticipantes.consultarPostulacion(id_postulacion);
    let { data } = await apiConvocatorias.getConvocatoriaById(decrypt(localStorage.getItem("idConvocatoriaPostulacion")))
    if (data.documentos_administrativos === null) data.documentos_administrativos = [];
    if (data.documentos_generales === null) data.documentos_generales = [];
    if (data.documentos_tecnicos === null) data.documentos_tecnicos = [];
    return setPostulacion(data);
  }
  return { postulacion, setPostulacion, cargarPostulacion, cargarPostulacionTipoParticipante };
};
